// simple animation that fades the entire
// elm in then subsequently animates any item that
// have data-animate attr

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
const lib = require('../library')
import { CSSPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default class AnimationLogos {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.heading = this.el.querySelectorAll('[data-heading]')
    this.copy = this.el.querySelectorAll('[data-copy]')
    this.logos = this.el.querySelectorAll('[data-logo]')
    this.motion = lib.userMotionEnabled()
  }

  init() {
    console.log('AnimationSimpleIn Loaded')
    if (this.motion) {
      this.handleScrollAnimation()
    }
  }

  // initial animation tied to scrolling
  handleScrollAnimation() {
    const tl = gsap.timeline({
      ease: 'power1.easeIn',
      duration: 0.3,
      scrollTrigger: {
        trigger: this.el,
        start: '35% bottom',
        toggleActions: 'play none none reverse',
      },
    })
    // @TODO: make sure to conditionally load based on availability
    gsap.set([this.heading, this.copy, this.logos], { autoAlpha: 0, y: 30 })

    tl.to(this.heading, { autoAlpha: 1, y: 0, duration: 0.3 })
    tl.to(this.copy, { autoAlpha: 1, y: 0, duration: 0.2 }, '-=0.2')
    tl.to(this.logos, {
      autoAlpha: 1, y: 0, stagger: 0.05, duration: 0.4,
    }, '-=0.2')
    tl.fromTo(this.logos, {
      filter: 'grayscale(0%)',
    }, { filter: 'grayscale(100%)', stagger: 0.1, duration: 0.4 }, '<+0.6')
  }
}
